import React from 'react';
import { StyleSheet, View } from 'react-native';
import UAEPassSvg from '@assets/images/svg/uaepassicon.svg';
import UAEPassWhiteSvg from '@assets/images/svg/uaepassicon-white.svg';

export interface UAEPassIconProps {
    size?: number;
    variant?: 'default' | 'white';
}

export function UAEPassIcon({ size = 24, variant = 'default' }: UAEPassIconProps) {
    const SvgComponent = variant === 'white' ? UAEPassWhiteSvg : UAEPassSvg;
    
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <SvgComponent
                width={size}
                height={size}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default UAEPassIcon;
